import { uniqueId } from 'lodash';

import React, { useCallback } from 'react';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { getTimeRange } from '../services/date.service';
import ButtonComponent from './Button.component';

export interface TimeChooserProps {
  date: number;
  onChange: Function;
}

const StyledTimeChooser = styled.div`
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(4, 1fr);
`;

const TimeChooserComponent = ({ date, onChange }: TimeChooserProps) => {
  const isActive = useCallback(
    (time: number) => {
      return dayjs(time).isSame(dayjs(date), 'minutes');
    },
    [date],
  );

  return (
    <StyledTimeChooser>
      {getTimeRange(date).map((dateTime: number) => (
        <ButtonComponent
          key={uniqueId('time-chooser-')}
          appearance={isActive(dateTime) ? 'primary' : 'default'}
          handleClick={() => onChange(dateTime)}
        >
          {dayjs(dateTime).format('HH:mm')}
        </ButtonComponent>
      ))}
    </StyledTimeChooser>
  );
};

export default TimeChooserComponent;
